define('views/modals/confirm',['require','backbone','marionette','jquery-validation','text!templates/modals/confirm.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('jquery-validation');

    var temp = require("text!templates/modals/confirm.html");

    return Backbone.Marionette.LayoutView.extend({
        template: _.template(temp),
        className: 'modal fade slide-up',

        initialize: function(options) {
            this.confirmText = options.confirmText;
            this.callback = options.callback;

            _.bindAll(this, 'teardown');
        },

        ui: function() {
            return {
                yesButton: '#yes',
                noButton: '#no'
            };
        },

        events: {
            'click @ui.yesButton': 'yesButtonClicked',
            'click @ui.noButton': 'noButtonClicked'
        },

        templateHelpers: function() {
            return {
                confirmText: this.confirmText
            };
        },

        onShow: function () {
            this.$el.modal();
        },

        show: function() {
            this.$el.modal('show');
            this.onShow();
        },

        teardown: function() {
            this.$el.data('modal', null);
            this.remove();
        },

        close: function () {
            this.$el.modal('hide');
        },

        yesButtonClicked: function () {
            this.callback();
            this.close();
        },

        noButtonClicked: function () {
            this.close();
        }

    });
});

